import i18nFactory from '@yandex-int/i18n';

import { CampaignType } from '../../typings/domain';

import * as keyset from './MinusPhraseService.i18n';

const i18n = i18nFactory(keyset);

const MINUS_PHRASES_CAMPAIGN_TYPES = [
    CampaignType.TEXT,
    CampaignType.PERFORMANCE
];

export function getSuccessMinusPhraseBindingMessage(
    totalGroups: number,
    successGroupsCount: number,
    minusPhrasesListCount: number
): string {
    if (minusPhrasesListCount > 1) {
        if (successGroupsCount === totalGroups) {
            if (successGroupsCount > 1) {
                return i18n(
                    'minus-phrase-binding-many-phrases-list-success-many',
                    {
                        count: successGroupsCount
                    }
                );
            } else {
                return i18n(
                    'minus-phrase-binding-many-phrases-list-success-one',
                    {
                        count: successGroupsCount
                    }
                );
            }
        } else {
            return i18n('minus-phrase-binding-many-phrases-list-warning', {
                count: successGroupsCount,
                total: totalGroups
            });
        }
    } else {
        if (successGroupsCount === totalGroups) {
            if (successGroupsCount > 1) {
                return i18n(
                    'minus-phrase-binding-one-phrases-list-success-many',
                    {
                        count: successGroupsCount
                    }
                );
            } else {
                return i18n(
                    'minus-phrase-binding-one-phrases-list-success-one',
                    {
                        count: successGroupsCount
                    }
                );
            }
        } else {
            return i18n('minus-phrase-binding-one-phrases-list-warning', {
                count: successGroupsCount,
                total: totalGroups
            });
        }
    }
}

export function getErrorMinusPhraseBindingMessage(
    minusPhrasesListCount: number,
    totalGroups: number
): string {
    if (minusPhrasesListCount > 1) {
        if (totalGroups > 1) {
            return i18n('minus-phrase-binding-many-phrases-list-error-many');
        } else {
            return i18n('minus-phrase-binding-many-phrases-list-error-one');
        }
    } else {
        if (totalGroups > 1) {
            return i18n('minus-phrase-binding-one-phrases-list-error-many');
        } else {
            return i18n('minus-phrase-binding-one-phrases-list-error-one');
        }
    }
}

export function getSuccessMinusPhraseUnbindingMessage(
    totalGroups: number,
    successGroupsCount: number,
    minusPhrasesListCount: number
): string {
    if (minusPhrasesListCount > 1) {
        if (successGroupsCount === totalGroups) {
            if (successGroupsCount > 1) {
                return i18n(
                    'minus-phrase-unbinding-many-phrases-list-success-many'
                );
            } else {
                return i18n(
                    'minus-phrase-unbinding-many-phrases-list-success-one'
                );
            }
        } else {
            return i18n('minus-phrase-unbinding-many-phrases-list-warning', {
                count: successGroupsCount,
                total: totalGroups
            });
        }
    } else {
        if (successGroupsCount === totalGroups) {
            if (successGroupsCount > 1) {
                return i18n(
                    'minus-phrase-unbinding-one-phrases-list-success-many'
                );
            } else {
                return i18n(
                    'minus-phrase-unbinding-one-phrases-list-success-one'
                );
            }
        } else {
            return i18n('minus-phrase-unbinding-one-phrases-list-warning', {
                count: successGroupsCount,
                total: totalGroups
            });
        }
    }
}

export function getErrorMinusPhraseUnbindingMessage(
    minusPhrasesListCount: number,
    totalGroups: number
): string {
    if (minusPhrasesListCount > 1) {
        if (totalGroups > 1) {
            return i18n('minus-phrase-unbinding-many-phrases-list-error-many');
        } else {
            return i18n('minus-phrase-unbinding-many-phrases-list-error-one');
        }
    } else {
        if (totalGroups > 1) {
            return i18n('minus-phrase-unbinding-one-phrases-list-error-many');
        } else {
            return i18n('minus-phrase-unbinding-one-phrases-list-error-one');
        }
    }
}

export function isCampaignTypeSupportsMinusPhraseLibrary(
    campaignType: CampaignType
): boolean {
    return MINUS_PHRASES_CAMPAIGN_TYPES.includes(campaignType);
}
